import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	popOutLabel: {
		id: 'servicedesk-queues-nav4.common.popout-toggle-button.pop-out-label',
		defaultMessage: 'Pop out queues navigation',
		description:
			'Accessibility label for the button to pop-out the queues navigation menu from the sidebar into the main pages content',
	},
	popInLabel: {
		id: 'servicedesk-queues-nav4.common.popout-toggle-button.pop-in-label',
		defaultMessage: 'Pop in queues navigation',
		description:
			'Accessibility label for the button to pop-in the queues navigation menu from the main pages content into the sidebar',
	},
});
